import useChangeEmailRequestForm from "./useChangeEmailRequestForm";
import {Button, Field, FieldsContainer, Form, PasswordField, Spacer, TextField, Toolbar} from "common";
import React from "react";
import I18n from "i18n-js";

interface ChangeEmailRequestFormProps {
  onRequestSent: Function;
}

export default function ChangeEmailRequestForm({onRequestSent}: ChangeEmailRequestFormProps) {

  const {
    item,
    errors,
    loading,
    process,
    onChange,
  } = useChangeEmailRequestForm({onRequestSent});

  return (
    <>
      <Form
        item={item}
        errors={errors}
        onChange={onChange}
        translationCategory="Profile.changeEmailRequest.attributes"
      >
        <FieldsContainer>
          <Field fullWidth>
            <Spacer h={2} />
            <TextField id="email" />
          </Field>
          <Field fullWidth>
            <PasswordField fake id="password" />
          </Field>
        </FieldsContainer>
      </Form>
      <Spacer h={2} />
      <Toolbar>
        <Spacer right />

        <Button
          title={I18n.t("App.save")}
          onClick={() => process()}
          loading={loading}
        />
      </Toolbar>
    </>
  );
}